import { render, staticRenderFns } from "./Slide.vue?vue&type=template&id=36d27673&scoped=true&"
import script from "./Slide.vue?vue&type=script&lang=js&"
export * from "./Slide.vue?vue&type=script&lang=js&"
import style0 from "./Slide.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Slide.vue?vue&type=style&index=1&id=36d27673&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d27673",
  null
  
)

export default component.exports